import { Config, AuthHeader } from "../helpers/Config";
import { UserService } from "./UserService";

export const PaymentService = {
    /**
     * [DEPOSIT]
     */
    Deposit: {
        /**
         * [COMMUNITY_BANK]
         */
        CommunityBank: {
            /**
             * [BANK_LIST]
             */
            BankList() {

                var requestOptions = {
                    method: 'GET',
                    headers: AuthHeader()
                }

                return PaymentService.Common.Fetch(Config.service.payment.deposit.CommunityBank.BankList, requestOptions);

            },
            /**
             * [AMOUNT_LIST]
             * @param {object} data
             * @param {string} data.swiftCode
             * @param {string} data.accessToken
             */
            AmountList(data) {

                var requestOptions = {
                    method: 'POST',
                    headers: AuthHeader(),
                    body: JSON.stringify(data)
                }

                return PaymentService.Common.Fetch(Config.service.payment.deposit.CommunityBank.AmountList, requestOptions);
            }
        },
        /**
            * [BTCPAY_PAYMENT_INFORMATION]
            * @param {object} data
            * @param {string} data.login
            * @param {string} data.isNew
            */
        BtcPay(data) {

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify(data)
            }
            return PaymentService.Common.Fetch(Config.service.payment.deposit.BtcPay, requestOptions);
        },
        TPay(data) {

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify(data)
            }
            return PaymentService.Common.Fetch(Config.service.payment.deposit.TPay, requestOptions);
        },
        TPayTRC20Pay(data) {

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify(data)
            }
            return PaymentService.Common.Fetch(Config.service.payment.deposit.TPayTRC20Pay, requestOptions);
        },
        Unipayment: {
            getInvoices(data) {

                var requestOptions = {
                    method: 'POST',
                    headers: AuthHeader(),
                    body: JSON.stringify(data)
                }
                return PaymentService.Common.Fetch(Config.service.payment.deposit.Unipayment.getInvoices, requestOptions);
            },
            getInvoice(invoiceId) {

                var requestOptions = {
                    method: 'GET',
                    headers: AuthHeader()
                }
                return PaymentService.Common.Fetch(Config.service.payment.deposit.Unipayment.getInvoice + '/' + invoiceId, requestOptions);
            },
        },

    },
    /**
     * [WITHDRAWAL]
     */
    Withdrawal: {
        /**
         * [NETELLER]
         */
        NetellerAccount() {

            var requestOptions = {
                method: 'GET',
                headers: AuthHeader()
            }

            return PaymentService.Common.Fetch(Config.service.payment.withdrawal.NetellerAccount, requestOptions);

        },
        /**
         * [SKRILL]
         */
        SkrillAccount() {

            var requestOptions = {
                method: 'GET',
                headers: AuthHeader()
            }

            return PaymentService.Common.Fetch(Config.service.payment.withdrawal.SkrillAccount, requestOptions);
        }
    },

    /**
     * [PRICE]
     */
    Price(data) {
        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return PaymentService.Common.Fetch(Config.service.payment.price, requestOptions);
    },
    /**
     * [PRICE]
     */
    CoinPrice(data) {
        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return PaymentService.Common.Fetch(Config.service.payment.coinPrice, requestOptions);
    },
    /**
     * [COMMON]
     * @function Fetch
     */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {
                        UserService.Logout();
                        window.location.reload();
                    }
                    else {
                        throw new Error();
                    }
                }).then((json) => {

                    return json;

                }).catch(function () {
                    return false;
                });

        }
    }
}
